module.exports = __webpack_public_path__ + "static/media/lamp-floor.06cba342.svg";